<template>
  <b-container>

  <p class="text-center mt-2 text-attr-info">{{$t('info.form')}}</p>
  <hr>
  <b-form @submit="onSubmit">

    <b-row>
      <b-col sm class="mt-2">
        <label for="lname">{{$t('label.lname')}}<span class="ml-2 text-success font-weight-bold">*</span></label>
        <b-form-input v-model.trim="$v.form.lname.$model" name="lname"></b-form-input>
        <div class="text-danger" v-if="!$v.form.lname.required && $v.form.lname.$dirty">{{ $t("info.required") }}</div>
        <div class="text-danger" v-if="!$v.form.lname.maxLength && $v.form.lname.$dirty">{{ $t("info.maxLength", [50]) }}</div>
      </b-col>
      <b-col sm class="mt-2">
        <label for="fname">{{$t('label.fname')}}<span class="ml-2 text-success font-weight-bold">*</span></label>
        <b-form-input v-model.trim="$v.form.fname.$model" name="fname"></b-form-input>
        <div class="text-danger" v-if="!$v.form.fname.required && $v.form.fname.$dirty">{{ $t("info.required") }}</div>
        <div class="text-danger" v-if="!$v.form.fname.maxLength && $v.form.fname.$dirty">{{ $t("info.maxLength", [50]) }}</div>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm class="mt-2">
        <label for="property">{{$t('label.building')}}<span class="ml-2 text-success font-weight-bold">*</span></label>
        <b-form-select v-model.trim="$v.form.building.$model" :options="buildings" name="property"></b-form-select>
        <div class="text-danger" v-if="!$v.form.building.required && $v.form.building.$dirty">{{ $t("info.required") }}</div>
      </b-col>
      <b-col sm class="mt-2">
        <label for="appartement">{{$t('label.appartement')}}<span class="ml-2 text-success font-weight-bold">*</span></label>
        <b-form-input v-model.trim="$v.form.appartement.$model" name="appartement"></b-form-input>
        <div class="text-danger" v-if="!$v.form.appartement.required && $v.form.appartement.$dirty">{{ $t("info.required") }}</div>
        <div class="text-danger" v-if="!$v.form.appartement.maxLength && $v.form.appartement.$dirty">{{ $t("info.maxLength", [50]) }}</div>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="6" class="mt-2">
        <label for="email">{{$t('label.email')}}<span class="ml-2 text-success font-weight-bold">*</span></label>
        <b-form-input v-model.trim="$v.form.email.$model" name="email"></b-form-input>
        <div class="text-danger" v-if="!$v.form.email.required && $v.form.email.$dirty">{{ $t("info.required") }}</div>
        <div class="text-danger" v-if="!$v.form.email.email && $v.form.email.$dirty">{{ $t("info.email") }}</div>
        <div class="text-danger" v-if="!$v.form.email.maxLength && $v.form.email.$dirty">{{ $t("info.maxLength", [75]) }}</div>
      </b-col>
    </b-row>

    <div class="mt-2">
      <b-form-checkbox
          v-model="form.consent"
          name="consent"
          value="1"
          unchecked-value="0"
          size="md"
        >
          <span>{{ $t("info.consent") }}</span>
        </b-form-checkbox>
    </div>

    <b-row class="mt-2">
      <b-col class="text-center">
        <b-button size="lg" type="submit" variant="success" :disabled="disabled">{{ $t("action.submit") }}</b-button>
      </b-col>
    </b-row>

    <div v-if="success" class="pt-2">
      <b-alert :show="dismissCountDown" variant="success" dismissible @dismissed="dismissCountDown=0" @dismiss-count-down="countDownChanged">
        <p>{{ $t("info.successgeneric") }}</p>
        <p>{{ $t("info.alertcountdown", [dismissCountDown]) }}</p>
      </b-alert>
    </div>

    <div v-if="emailexist" class="pt-4">
      <b-alert :show="emailalert" variant="warning" dismissible>
        <p>{{ $t("info.emailexist") }}</p>
        <b-button size="sm" variant="outline-secondary" @click="emptyField()">{{ $t("action.clearField") }}</b-button>
      </b-alert>
    </div>

    <div v-if="error" class="pt-2">
      <b-alert show variant="danger" dismissible>
        <p>{{ $t("info.errorgeneric", [error]) }}</p>
      </b-alert>
    </div>

  </b-form>
</b-container>
</template>

<script>
import axios from 'axios';
import { required, email, maxLength } from 'vuelidate/lib/validators';

export default {
props: ["buildingslist", "regionslist"],
data: () => ({
  form: {
    fname: '',
    lname: '',
    email: '',
    appartement: '',
    building: null,
    consent: '0'
  },
  success: false,
  emailexist: false,
  error: "",
  disabled: false,
  dismissSecs: 5,
  dismissCountDown: 0,
  emailalert:true
}),
validations: {
  form: {
    fname: {
      required,
      maxLength: maxLength(50)
    },
    lname: {
      required,
      maxLength: maxLength(50)
    },
    email: {
      required,
      email,
      maxLength: maxLength(50)
    },
    appartement: {
      required,
      maxLength: maxLength(50)
    },
    building: {
      required
    },
    consent: {
      required
    }
  }
},
computed: {
  buildings: function () {
    let array = [];
    let buildings = this.buildingslist;
    if (buildings.length > 0) {
      for (let i = 0; i < buildings.length; i++) {
        let options = {};
        options.value = buildings[i].Id;
        options.text = buildings[i].Immeuble;
        array.push(options);
      }
      array.unshift({value: null, text: ""});
    }
    return array;
  }
 },
methods:{
    emptyField() {
      this.$v.$reset();
      this.form.lname = '';
      this.form.fname = '';
      this.form.email = '';
      this.form.appartement = '';
      this.form.consent = '0';
      this.emailalert = false;
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.success = false;
      this.emailexist = false;
      this.error = "";
      this.$v.$touch();

        if (!this.$v.$invalid) {

          this.disabled = true;
          let url = process.env.VUE_APP_WHERE;
          /*Ajax Call*/
          axios.post(url, {request: "getForms", form: this.form}, { headers: {'Content-Type': 'application/json'}})
             .then((response)  => {
               if (response.data === 0) {
                 this.success = true;
                 this.$v.$reset();
                 this.form.lname = '';
                 this.form.fname = '';
                 this.form.email = '';
                 this.form.appartement = '';
                 this.form.consent = '0';
                 this.disabled = false;
                 this.dismissCountDown = this.dismissSecs;
               }
               else if (response.data === "EmailExist") {
                 this.emailalert = true;
                 this.emailexist = true;
                 this.disabled = false;
               }
               else {
                 this.error = response.data;
                 this.disabled = false;
               }
               //this.disabled = false;
             })
             .catch((error)  => {
               this.error = error;
               this.disabled = false;
             });
        }
    }
  }
}
</script>
